import { useSmartFieldsPreferenceResource } from '@atlassian/jira-personal-settings-gic-smart-fields/src/ui/preference/index.tsx';

export const useSmartFieldsMachineLearning = () => {
	const { loading: loadingJiraLabsSmartFields, data: jiraLabsSmartFieldsData } =
		useSmartFieldsPreferenceResource();

	const hasUserOptedOut = jiraLabsSmartFieldsData?.hasUserOptedOut;

	const withMachineLearning = !loadingJiraLabsSmartFields && !hasUserOptedOut;

	return {
		withMachineLearning,
	};
};
